export default function getLazyLoadConfig(config, id) {
  if (!(config !== null && config !== void 0 && config.slots)) {
    return null;
  }

  var slotConfig = config.slots.find(function (slot) {
    return slot.id === id;
  });

  if (!slotConfig) {
    return null;
  }

  if (slotConfig.enableLazyLoad !== undefined && slotConfig.enableLazyLoad !== null) {
    return slotConfig.enableLazyLoad;
  }

  return (config === null || config === void 0 ? void 0 : config.enableLazyLoad) === undefined ? null : config === null || config === void 0 ? void 0 : config.enableLazyLoad;
}